/*no-unused-vars */
import React, { Component, Suspense } from "react";
import PropTypes from "prop-types";
import { CustomTitleV1, AddEmployeeStyledModal, Tile,/* CustomDropdown, CustomMenuItemEmployee, NewCustomDropdown,SearchIcon*/ TitleContainerEmployee, AddtoTeamButton, TileWraper, SearchInput, DropdownWrapper } from './styles';
import { Modal } from 'react-bootstrap';
import { ImageUrl } from "../../utils/constants";
import { connect } from "react-redux";
import {
  fetchUsersToAddToTeam,
  fetchAddTeamMembersData,
} from "../../redux/actions";
import _ from "lodash";
import Waiting from "../Waiting";
import LazyImage from "../common/LazyImage/LazyImage";
import { AdminCloseIcon, BirthdayAnniversaryFilterIcon, RecognitionTickIcon } from "../../utils/icons";
import { getInitials } from "../../utils/methods";
import { NameInitials } from "../Manager/styles";
import NewFilterPopup from "../common/CommonDeptLoc/NewFilterPopup";

// const ENTER_KEY = 13;

class AddUsersToTeamPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pointsDrop: false,
      departmentDrop: false,
      locationDrop: false,
      addButtondisabled: true,
      pointsData: [1, 2, 3, 4],
      department: null,
      locationDropDown: null,
      selectedPoints: "Points",
      departmentId: null,
      locationDropDownId: null,
      employeeSelected: false,
      employeeSelectedId: null,
      selectedEmployeeData: [],
      search: null,
    };
  }

  updateDropdown = (title, id, titleKey, idKey) => {
    window.console.log("titiel",title);
    window.console.log("id",id)
    this.setState(
      {
        [titleKey]: title,
        [idKey]: id,
      },
      () => {
        this.viewUsersToAdd();
      }
    );
  };

  viewUsersToAdd = () => {
    const { fetchUsersToAddToTeam, companyId } = this.props;
    const {
      department,
      locationDropDown,
      departmentId,
      locationDropDownId,
      search,
    } = this.state;
    let obj = {};
    obj["company_id"] = companyId;
    if (department) {
      obj["department_id"] = departmentId;
    }
    if (locationDropDown) {
      obj["city_state_id"] = locationDropDownId;
    }
    if (search) {
      obj["name"] = search;
    }
    fetchUsersToAddToTeam(obj);
  };

  onSelect = (name, value) => {
    this.setState({
      [name]: value,
    });
  };

  enableSelectedEmployee = (uid, status) => {
    let activeSelctedEmployee = [];
    if (status) {
      activeSelctedEmployee.push(uid);
      this.setState({
        selectedEmployeeData: this.state.selectedEmployeeData.concat(
          activeSelctedEmployee
        ),
      });
    } else {
      let newSelected = this.state.selectedEmployeeData.filter(
        (obj) => obj != uid
      );
      this.setState({
        selectedEmployeeData: newSelected,
      });
    }
  };

  submitTeamUsersToAdd = () => {
    const { teamId, hideModal } = this.props;
    const { selectedEmployeeData } = this.state;
    let obj = {};
    obj["team_id"] = teamId;
    obj["uids"] = selectedEmployeeData;
    this.postTeamUsersToAdd(obj);
    hideModal();
  };

  postTeamUsersToAdd = (obj) => {
    const { fetchAddTeamMembersData, pageNo, limit, companyId, teamId } =
      this.props;
    fetchAddTeamMembersData(obj, companyId, pageNo, limit, teamId);
    this.setState({
      selectedEmployeeData: [],
      department: null,
      locationDropDown: null,
    });
  };

  fallBack = (e) => {
    e.target.src = "/images/default.png";
  };

  hideModalData = () => {
    const { hideModal } = this.props;
    this.setState({
      selectedEmployeeData: [],
      department: null,
      locationDropDown: null,
    });
    hideModal();
  };

  onChange = (e) => {
    this.setState(
      {
        search: e.target.value,
      },
      () => {
        this.viewUsersToAdd();
      }
    );
  };

  setIsDropdownOpen = () => {
    this.setState({ departmentDrop: !this.state.departmentDrop });
  };

  render() {
    const {
      showModal,
      teamUsers,
      // departmentDetails,
      // locationDetails,
      /*memberCount, teamMembersCount*/
    } = this.props;
    const {
      // departmentDrop,
      // locationDrop,
      // department,
      // locationDropDown,
      selectedEmployeeData,
    } = this.state;
    // let enableDisableAddButton=0;
    // enableDisableAddButton = teamMembersCount+selectedEmployeeData.length;
    return (
      <Suspense fallback={<Waiting />}>
        <AddEmployeeStyledModal
          show={showModal}
          // onHide={hideModal}
          dialogClassName="modal-90w"
        >
          <Modal.Header>
            <Suspense fallback={<Waiting />}>
              <CustomTitleV1>
                <div>
                  <span>{"Select Employees To Add In The Team"}</span>
                  <span
                    className="closeImage"
                    onClick={() => this.hideModalData()}
                  >
                    <div>{AdminCloseIcon()}</div>
                  </span>
                </div>
              </CustomTitleV1>
            </Suspense>
          </Modal.Header>
          <Modal.Body>
            <DropdownWrapper
              noBorder
              scroll={
                this.props.departmentDetails &&
                !_.isNull(this.props.departmentDetails) &&
                this.props.departmentDetails.length > 15
                  ? 1
                  : 0
              }
            >
              <TitleContainerEmployee>
                <div className="searchText">Search Employee</div>
                {/* <div className="searchDiv"> */}
                <div className="searchContainer">
                  <SearchInput
                    type="text"
                    placeholder={"Find a Employee"}
                    onChange={(e) => this.onChange(e)}
                    // onKeyDown={this.handleKeyDown}
                  />
                  <div className="filter-icon" onClick={()=>this.setIsDropdownOpen()}>{BirthdayAnniversaryFilterIcon()}</div>
                </div>
              </TitleContainerEmployee>
              {
                <NewFilterPopup
                  companyId={this.props.companyId}
                  // fetchCelebrationsDetails={this.fetchCelebrationsDetails}
                  setIsDropdownOpen={this.setIsDropdownOpen}
                  isDropdownOpen={this.state.departmentDrop}
                  // activeSubTab={this.state.activeSubTab}
                  updateDropdown={this.updateDropdown}
                  // userType={userType}
                  // WellnessInterests={WellnessInterests}
                  // updateWellnessDropdown={this.updateWellnessDropdown}
                  filters={['department','location']}
                  selectType={"single"}
                  page={'active'}
                  locationDetails={this.props.locationDetails}
                  departmentDetails={this.props.departmentDetails}
                />
              }
              {/* {departmentDetails && departmentDetails.length > 1 && (
                <TitleContainerEmployee fullWidth>
                  <NewCustomDropdown
                    title={
                      this.state.department ? (
                        <div className="title" style={{fontFamily:"Rubik-Regular"}}> {department} </div>
                      ) : (
                        <div className="title" style={{fontFamily:"Rubik-Regular"}}>Department</div>
                      )
                    }
                    id="dropdown-recurring"
                    onClick={() =>
                      this.setState({ departmentDrop: !departmentDrop })
                    }
                    onSelect={(index, key) =>
                      this.updateDropdown(
                        departmentDetails[index].department,
                        departmentDetails[index].id,
                        "department",
                        "departmentId"
                      )
                    }
                  >
                    {departmentDetails && departmentDetails.length > 0
                      ? departmentDetails.map((item, index) => (
                        <CustomMenuItemEmployee
                          eventKey={index}
                          key={index}
                          active={this.state.department == item}
                          value={item}
                        >
                          {item.department}
                        </CustomMenuItemEmployee>
                      ))
                      : null}
                  </NewCustomDropdown>
                </TitleContainerEmployee>
              )} */}
              {/* {locationDetails && locationDetails.length > 1 && (
                <TitleContainerEmployee fullWidth>
                  <NewCustomDropdown
                    title={
                      locationDropDown ? (
                        <div className="title" style={{fontFamily:"Rubik-Regular"}}> {locationDropDown}</div>
                      ) : (
                        <div className="title" style={{fontFamily:"Rubik-Regular"}}>Locations</div>
                      )
                    }
                    id="dropdown-recurring"
                    onClick={() =>
                      this.setState({ locationDrop: !locationDrop })
                    }
                    onSelect={(index, key) =>
                      this.updateDropdown(
                        locationDetails[index].location,
                        locationDetails[index].id,
                        "locationDropDown",
                        "locationDropDownId"
                      )
                    }
                  >
                    {locationDetails && locationDetails.length > 0
                      ? locationDetails.map((item, index) => (
                        <CustomMenuItemEmployee
                          eventKey={index}
                          key={index}
                          active={this.state.locationDropDown == item}
                        >
                          {item.location}
                        </CustomMenuItemEmployee>
                      ))
                      : null}
                  </NewCustomDropdown>
                </TitleContainerEmployee>
              )} */}
              {/* <TitleContainerEmployee fullWidth>
              <CustomDropdown
                title={<div className="title">{selectedPoints}</div>}
                id="dropdown-recurring"
                onClick={() => this.setState({ pointsDrop: !pointsDrop })}
              >
                {this.state.pointsData.length > 0 ? this.state.pointsData.map((item, index) => <CustomMenuItemEmployee
                  eventKey={index}
                  key={index}
                  onSelect={() => this.onSelect('selectedPoints', item)}
                  active={selectedPoints == item}
                >{item}
                </CustomMenuItemEmployee>)
                  : null}
              </CustomDropdown>
            </TitleContainerEmployee> */}
            </DropdownWrapper>
            {teamUsers.length ? (
              <TileWraper padding="1">
                {teamUsers.map((member, index) => (
                  <Tile key={index} checkIconColor={selectedEmployeeData.includes(member.uid) ? "1px solid #F37A65" : "1px solid #7C7C7C"}>
                    {member.profile_image !=="profile-Image/default.png" ?<LazyImage
                      onError={this.fallBack}
                      src={`${ImageUrl}/${member.profile_image}`}
                      alt="people_icon"
                    />:(<NameInitials id="name-initials" isBg={"#FEFEFE"} style={{marginRight:"12px"}}>
                      {getInitials(member?.fullname)}</NameInitials>)}
                    <div className="textBox">
                      <h1>{member.fullname}</h1>
                      {/* <h2>{member.department}</h2> */}
                      {/* {member.location !== "null" && <h2>{member.location}</h2>} */}
                    </div>
                    {selectedEmployeeData.includes(member.uid) ? (
                      <div
                        className="radioButton"
                        onClick={() =>
                          this.enableSelectedEmployee(member.uid, false)
                        }
                      >
                        <div className="checkIcon" > {RecognitionTickIcon("#F37A65",12,12)}</div>
                      </div>
                    ) : (
                      <div
                        className="radioButton"
                        onClick={() =>
                          this.enableSelectedEmployee(member.uid, true)
                        }
                      />
                    )}
                  </Tile>
                ))}
              </TileWraper>
            ) : (
              <div className="userText">No Data Found</div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <AddtoTeamButton
              disabled={selectedEmployeeData.length === 0}
              onClick={
                selectedEmployeeData.length === 0
                  ? ""
                  : () => this.submitTeamUsersToAdd()
              }
            >
            Save changes
            </AddtoTeamButton>
          </Modal.Footer>
        </AddEmployeeStyledModal>
      </Suspense>
    );
  }
}

AddUsersToTeamPopup.propTypes = {
  history: PropTypes.object.isRequired,
  showModal: PropTypes.bool,
  hideModal: PropTypes.func,
  teamUsers: PropTypes.array,
  locationDetails: PropTypes.array,
  departmentDetails: PropTypes.array,
  companyId: PropTypes.number,
  fetchUsersToAddToTeam: PropTypes.func,
  fetchAddTeamMembersData: PropTypes.func,
  teamId: PropTypes.number,
  teamDetailsData: PropTypes.array,
  pageNo: PropTypes.number,
  limit: PropTypes.number,
  memberCount: PropTypes.number,
  teamMembersCount: PropTypes.number,
};

const mapStateToProps = (state) => ({
  locationDetails: state.companyDashboard.companyPeopleLocation,
  departmentDetails: state.companyDashboard.companyPeopleDepartment,
  teamUsers: state.adminTeamCreation.teamUsers,
  teamDetailsData: state.adminTeamCreation.teamDetailsData,
});

const mapDispatchToProps = (dispatch) => ({
  fetchUsersToAddToTeam: (object) => dispatch(fetchUsersToAddToTeam(object)),
  fetchAddTeamMembersData: (object, companyId, pageNo, limit, teamId) =>
    dispatch(fetchAddTeamMembersData(object, companyId, pageNo, limit, teamId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddUsersToTeamPopup);
